import {
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	Divider,
	Step,
	StepLabel,
	Stepper,
	Tooltip,
	Typography,
} from "@mui/material"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { handleLinkClick } from "../../../store/actions/template"

const GuideDialog = ({
	open,
	onClose,
}: {
	open: boolean
	onClose: () => void
}) => {
	const { t } = useTranslation()
	const [activeStep, setActiveStep] = useState(0)

	const fieldDescriptions = [
		{
			name: "Transaction ID",
			description:
				"Campo riservato ad un id transazione che sia di interesse per la tua compagnia. Ti potrà servire per un'eventuale quadratura.",
			example: "PNX-123",
			type: "Stringa",
		},
		{
			name: "Sender Company",
			description:
				"Nome o Ragione sociale dell'ordinante dei plick creati con la distinta",
			example: "Mia Energia srl",
			type: "Stringa",
		},
		{
			name: "Sender Device",
			description: t("sos.fields.senderDevice"),
			example: "+391234567890 oppure mario.rossi@email.com",
			type: "Numero",
		},
		{
			name: "Sender Language Preferences",
			description: "Numero di telefono con prefisso",
			example: "+39 123 4567890",
			type: "Numero",
		},
		{
			name: "Sender Extra Info",
			description: "Numero di telefono con prefisso",
			example: "+39 123 4567890",
			type: "Numero",
		},
		{
			name: "Receiver Name",
			description: "Numero di telefono con prefisso",
			example: "+39 123 4567890",
			type: "Numero",
		},
		{
			name: "Receiver Device",
			description: "Numero di telefono con prefisso",
			example: "+39 123 4567890",
			type: "Numero",
		},
		{
			name: "Receiver Iban",
			description: "Numero di telefono con prefisso",
			example: "+39 123 4567890",
			type: "Numero",
		},
		{
			name: "Receiver Iban From Bank",
			description: "Numero di telefono con prefisso",
			example: "+39 123 4567890",
			type: "Numero",
		},
		{
			name: "Activation Date",
			description: "Numero di telefono con prefisso",
			example: "+39 123 4567890",
			type: "Numero",
		},
		{
			name: "Amount",
			description: "Numero di telefono con prefisso",
			example: "+39 123 4567890",
			type: "Numero",
		},
		{
			name: "Causal",
			description: "Numero di telefono con prefisso",
			example: "+39 123 4567890",
			type: "Numero",
		},
		{
			name: "Pin",
			description: "Numero di telefono con prefisso",
			example: "+39 123 4567890",
			type: "Numero",
		},
		{
			name: "PIN Type",
			description: "Numero di telefono con prefisso",
			example: "+39 123 4567890",
			type: "Numero",
		},
	]

	const handleNext = () => setActiveStep((prevActiveStep) => prevActiveStep + 1)
	const handleBack = () => setActiveStep((prevActiveStep) => prevActiveStep - 1)

	return (
		<Dialog open={open} onClose={() => onClose()} maxWidth="md">
			<DialogTitle>{t("sos.drawer.title", { ns: "upload" })}</DialogTitle>
			<DialogContent>
				{activeStep === 0 ? (
					<>
						<Typography>
							{t("sos.drawer.welcome", { ns: "upload" })}
							<br /> {t("sos.drawer.description", { ns: "upload" })}
						</Typography>
						<Button
							variant="contained"
							color="primary"
							onClick={(e) => {
								e.preventDefault()
								handleLinkClick(e, "template", "xls")
							}}
						>
							{t("sos.drawer.uploadXLS", { ns: "upload" })}
						</Button>
						<Button
							variant="contained"
							color="secondary"
							style={{ marginLeft: 10 }}
						>
							{t("sos.drawer.uploadCSV", { ns: "upload" })}
						</Button>
						<Typography>
							{t("sos.drawer.descriptionMore", { ns: "upload" })}
						</Typography>
						<div>
							<Button
								variant="outlined"
								color="primary"
								onClick={handleNext}
								style={{ marginTop: 20 }}
							>
								{t("sos.drawer.start", { ns: "upload" })}
							</Button>
						</div>
					</>
				) : (
					<>
						<Stepper activeStep={activeStep - 1} orientation="vertical">
							{fieldDescriptions.map((field, index) => (
								<Step key={field.name}>
									<StepLabel>{field.name}</StepLabel>
									<Typography variant="body2">{field.description}</Typography>
									<Typography variant="body2" color="textSecondary">
										{t("sos.drawer.type", { ns: "upload" })}: {field.type}
									</Typography>
									<Tooltip title={`Esempio: ${field.example}`}>
										<Typography variant="caption">
											{t("sos.drawer.example", { ns: "upload" })}:{" "}
											{field.example}
										</Typography>
									</Tooltip>
									{index < fieldDescriptions.length - 1 && (
										<Divider style={{ margin: "10px 0" }} />
									)}
								</Step>
							))}
						</Stepper>
						<div style={{ marginTop: 20 }}>
							<Button disabled={activeStep === 1} onClick={handleBack}>
								{t("sos.drawer.buttons.back", { ns: "upload" })}
							</Button>
							<Button
								variant="contained"
								color="primary"
								onClick={handleNext}
								disabled={activeStep === fieldDescriptions.length}
							>
								{activeStep === fieldDescriptions.length
									? t("sos.drawer.buttons.end", { ns: "upload" })
									: t("sos.drawer.buttons.next", { ns: "upload" })}
							</Button>
						</div>
					</>
				)}
			</DialogContent>
		</Dialog>
	)
}

export default GuideDialog
